import axios from 'axios'
import APIConfig from '@/data/remote/APIConfig.js'

export default class SalaryService {
    constructor() {
        this.apis = {
            // getAll: () => axios.get(APIConfig.APIURL + '/salary'),
            // add: (payload) => axios.post(APIConfig.APIURL + '/salary', payload),
            // edit: (id, payload) => axios.put(APIConfig.APIURL + `/salary/${id}`, payload),
            // inActivate: (id) => axios.post(APIConfig.APIURL + `/salary/${id}/inactivate`),
            // delete: (id) => axios.delete(APIConfig.APIURL + `/salary/${id}`),
            getByMonth: (year, month) => axios.get(APIConfig.APIURL + `/salary/month?Year=${year}&Month=${month}`),
            sign: (id, payload) => axios.post(APIConfig.APIURL + `/salary/${id}/sign`, payload),
        }
    }

    // prepareData(vm) {
    //     return new Promise((resolve, reject) => {
    //         if (vm.$store.state.salary.isFetched) {
    //             resolve(vm.$store.state.salary.list)
    //             return
    //         }
    //         if (vm.$store.state.salary.isFetching) {
    //             var timer = setInterval(() => {
    //                 if (vm.$store.state.salary.isFetching) return
    //                 clearInterval(timer)
    //                 if (vm.$store.state.salary.isFetched) {
    //                     resolve(vm.$store.state.salary.list)
    //                 } else {
    //                     reject('無法取得資料，請嘗試重新整理')
    //                 }
    //             }, 500)
    //             return
    //         }
    //         return this.getAll(vm)
    //             .then(res => {
    //                 vm.$store.state.salary.isFetched = true
    //                 vm.$store.state.salary.list = res.data.result || []
    //                 return res
    //             })
    //             .then(res => {
    //                 vm.$store.state.salary.isFetching = false
    //                 resolve()
    //                 return res
    //             })
    //             .catch(err => {
    //                 vm.$store.state.salary.isFetching = false
    //                 reject(err)
    //             })
    //     })
    // }

    getAll(vm) {
        return new Promise((resolve, reject) => {
            this.apis.getAll()
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    add(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.add(payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    edit(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.edit(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    inActivate(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.inActivate(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    delete(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.delete(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    getByMonth(vm, year, month) {
        return new Promise((resolve, reject) => {
            this.apis.getByMonth(year, month)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    sign(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.sign(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }
}
